export const PLACE_ORDER = "PLACE_ORDER";
export const PIX = "PIX";
